import React from 'react'
import CustomLink from './CustomLink'

const VoipUnlimited = (props) => {
    return (
        <table width='100%' cellPadding='2'>
            <tbody>
                <tr>
                    <td>Unlimited local & national calls</td>
                </tr>
                <tr>
                    <td>Unlimited 1300/13 calls</td>
                </tr>
                <tr>
                    <td>Unlimited calls to Australian mobiles (in Aus)</td>
                </tr>
                <tr>
                    <td>Unlimited international calls to:  UK, New Zealand, USA, Germany, Hong Kong, Japan, France, Canada, China, Singapore, India and Croatia. <CustomLink to='https://www.exetel.com.au/phone/voip-international'>Other country call rates</CustomLink>
                    </td>
                </tr>
            </tbody>
        </table>
    )
}

export default VoipUnlimited



// WEBPACK FOOTER //
// ./resources/js/components/VoipUnlimited.js